<template>
  <div class="ele-body">
    <el-card shadow="never" body-style="padding-bottom:0;" style="margin-bottom: 15px">
      <div class="ele-table-tool">
        <div class="ele-table-tool-title">短信收发记录</div>
      </div>
      <el-tabs v-model="active" class="top-card-tabs" @tab-click="tabChange">
        <!--        <el-tab-pane label="按角色发送短信" name="/smsManage/adminSMS/fromRole"/>-->
        <el-tab-pane label="发送记录" name="/smsRecord/messageRecord/sendRecord" />
        <!--        <el-tab-pane label="按部门发送短信" name="/smsManage/adminSMS/fromDept"/>-->
        <el-tab-pane label="接收记录" name="/smsRecord/messageRecord/receiveRecord" />
      </el-tabs>
    </el-card>
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'MessageRecord',
    data() {
      return {};
    },
    computed: {
      active: {
        get() {
          return this.$route.path;
        },
        set() {},
      },
    },
    methods: {
      /* 切换tab */
      tabChange(tab) {
        if (this.$route.path !== tab.name) this.$router.push(tab.name);
      },
    },
  };
</script>

<style scoped>
  .top-search-group {
    max-width: 500px;
    margin: 0 auto 25px;
    display: flex;
  }

  .top-search-group >>> .el-input input {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right-width: 0;
  }

  .top-search-group .el-button {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .top-card-tabs >>> .el-tabs__nav-wrap:after {
    display: none;
  }

  .top-card-tabs {
    margin-left: 5px;
  }
</style>
